import { render, staticRenderFns } from "./EditMessage.vue?vue&type=template&id=57cebc62&scoped=true&"
import script from "./EditMessage.vue?vue&type=script&lang=js&"
export * from "./EditMessage.vue?vue&type=script&lang=js&"
import style1 from "./EditMessage.vue?vue&type=style&index=1&id=57cebc62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cebc62",
  null
  
)

export default component.exports